<template>
    <rkm-data-table
        :fields="fields.datatables.procedimento"
        :repository="repositories.procedimentoCirurgico"
        ref="DataTable"
        sort-by="nome"
        search-by="nome"
    >
        <template v-slot:cell(procedimentoCodigo)="{ value }">
            {{ value | procedimentoCodigo }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'parametrizacao-procedimento-cirurgico-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-parametrizacao-procedimento-cirurgico"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="item.status === 'ATIVO'"
                @click.stop="handleDisable(item, false)"
                color="warning"
                authorize="update-parametrizacao-procedimento-cirurgico"
                title="Desativar"
                small
            >
                <rkm-icon icon="ban" />
            </rkm-button>

            <rkm-button
                v-else
                @click.stop="handleActivate(item, true)"
                color="success"
                authorize="update-parametrizacao-procedimento-cirurgico"
                title="Ativar"
                small
            >
                <rkm-icon icon="ban" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-parametrizacao-procedimento-cirurgico"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    procedimento: [
                        {
                            name: 'parametrizacaoProcedimentoCirurgico.procedimentoCodigo',
                            key: 'procedimentoCodigo',
                            label: 'Procedimento',
                            searchable: true,
                            sortable: true,
                            class: 'col-min'
                        },
                        {
                            name: 'parametrizacaoProcedimentoCirurgico.nome',
                            key: 'nome',
                            label: 'Nome',
                            searchable: true,
                            sortable: true
                        },
                        {
                            name: 'cadastroGrupo.nome',
                            key: 'grupo',
                            label: 'Grupo',
                            searchable: true,
                            sortable: true
                        },
                        {
                            name: 'actions',
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min'
                        },
                        {
                            name: 'parametrizacaoProcedimentoCirurgico.grupoExameId',
                            key: 'grupoExameId',
                            class: 'd-none'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            procedimentoCirurgico: this.getConectaSusRepository('parametrizacao.procedimentoCirurgico')
        }
    },
    filters: {
        procedimentoCodigo: formats.formatProcedimento
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.procedimentoCirurgico.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir procedimento cirúrgico?', destroy, this.handleError)
        },
        handleDisable(item, action) {

            this.repositories.procedimentoCirurgico.update(item.id, this.prepareData(item, action))
                .then(() => this.$refs.DataTable.refresh())
        },
        handleActivate(item, action) {

            this.repositories.procedimentoCirurgico.update(item.id, this.prepareData(item, action))
                .then(() => this.$refs.DataTable.refresh())
        },
        prepareData(item, action) {

            if (action === false) {

                item.status = 0
            }

            if (action === true) {

                item.status = 1
            }

            delete item.grupo;

            return this.camelObjectKeysToSnakeRecursive(item)
        }
    },
    mixins: [repository, error, stringCase],
}
</script>